<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/SignIn'

    export default {
        components: {
            Grid,
        }
    }
</script>